import React from "react";

import Box from "components/Box";

const VisuallyHidden = props => {
  return <Box as="span" variant="visuallyHidden" {...props} />;
};

export default VisuallyHidden;
